import { useStores } from "core/stores";
import { observer } from "mobx-react-lite";
import React, { useState, useEffect, Fragment, useMemo } from "react";
import "./NewUser.css";
import { useNavigate, useParams } from "react-router-dom";
//import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { IADUser } from "common/interfaces/IADUser";
import { Spinner } from "components/common/Spinner";
import 'react-data-grid/lib/styles.css';

import ReactDataGrid,  {Column} from "react-data-grid";

interface NewUserProp {
    children: JSX.Element;
}

export const NewUser = observer((props: NewUserProp) => {
    const [searchText, setSearchText] = useState<string>("");
    const navigate = useNavigate();
    const [isSearchTextValid, setIsSearchTextValid] = useState<boolean>(true);

    const [adUsers, setADUsers] = useState<IADUser[]>([]);

    const [showLoader, setShowLoader] = useState<boolean | undefined>(undefined);

    const [showGrid, setShowGrid] = useState<boolean | undefined>(false);

    const { userStore } = useStores();

    const [columns, setColumns] = useState<any[]>([]);   

    const getColumns = () => {      

        const columns = [
            {
                key: "mail",
                name: "Email",
                 renderCell: (params: any) => (
                    <a className="hyperink" href="#" onClick={() => userClickHandler(params.row.mail, params.row.firstName, params.row.surname)}>
                        {params.row.mail}
                    </a>
                ),
            },
            {
                key: "firstName",
                name: "Firstname",
            },
            {
                key: "surname",
                name: "Surname",
            },
        ];

        return columns;
    };

    useEffect(() => {
        userStore.adusers = [];
    }, []);

    useEffect(() => {
        if (userStore.adusers.length > 0) {
            setShowGrid(true);
        }
    }, [adUsers]);

    const onSearchTextChange = (e: any) => {
        setSearchText(e.target.value);
    };

    const validate = () => {
        let isValid = true;
        isValid = searchText.length < 3 ? false : true;
        setIsSearchTextValid(isValid);
        if (!isValid) return false;
        return isValid;
    };
    const onSearchHandle = (e: any) => {
        if (validate()) {
            setColumns(getColumns);
            setShowLoader(true);
            let response: IADUser[];
            userStore.getAdUsers(searchText).then((data) => {
                setADUsers(data);
            });

            setShowLoader(false);
        } else {
            console.log("Validation failed");
        }
    };  

    const onCancelClick = () => {
        navigate("/users");
    };

    const userClickHandler = async (email: string, firstName: string, surname: string) => {
        userStore.newUser.name = `${firstName} ${surname}`;
        userStore.newUser.email = `${email}`;
        await userStore.resetSelectedUser();
        navigate(`/addEditUser`);
    };

    return (
        <div className="container-fluid p-1">
            <div className="m-4 card">
                <div className="card-header">
                    <div className="row">
                        <div className="col-6 align-content-center">
                            <h1>New User Configuration</h1>
                        </div>
                    </div>
                </div>
                <div className="row card-body w-100 h-100">
                    <form className="needs-validation">
                        <div className="form-group row pb-2">
                            <label htmlFor="name" className="col-md-2 col-form-label">
                                Search for User
                            </label>
                            <div className="col-md-4">
                                <input
                                    type="name"
                                    name="name"
                                    required
                                    value={searchText}
                                    onChange={onSearchTextChange}
                                    className={isSearchTextValid ? "form-control" : "form-control is-invalid"}
                                    id="inputName"
                                    placeholder="Name"
                                />
                            </div>
                        </div>
                        <div className="form-group row pt-3">
                            <div className="col-md-6">
                                <span className="text-secondary small">
                                    Note: If user is a new starter in the organisation and you are unable to find them, please raise an IT support ticket.
                                </span>
                            </div>
                        </div>
                        <div className="form-group row button-row-margin">
                            <div className="col-md-12">
                                <button className="btn btn-primary" onClick={onSearchHandle} type="button">
                                    Search
                                </button>
                                <a className="btn btn-primary ms-1" onClick={onCancelClick}>
                                    Cancel
                                </a>
                            </div>
                        </div>
                        <div className="row card-body w-100 h-100">
                            <div className="col table-responsive p-2">                              
                                {adUsers.length > 0 && columns.length > 0 && <ReactDataGrid  columns={columns} rows={adUsers} />}
                                 {showLoader && <Spinner />} 
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
});
